/**
 * One shape for every kind of run history row. Schedule and trigger runs are conversations (`threadId`,
 * read through their events); workflow runs are workflow runs (`workflowRunId`, read through the run's
 * step record). Newest first.
 */
const buildAutomationRunRows = ({ kind, runs = [] }) => {
  const rows =
    kind === 'workflows'
      ? runs.map((run) => ({
          id: run.id,
          status: run.status,
          startedAt: run.startedAt || run.createdAt,
          finishedAt: run.finishedAt,
          error: run.failureReason || null,
          source: run.sourceType || null,
          threadId: null,
          workflowRunId: run.id
        }))
      : runs.map((run) => ({
          id: run.runId || run.threadId,
          status: run.runState,
          startedAt: run.runCreatedAt || run.threadCreatedAt,
          finishedAt: run.runCompletedAt,
          error: run.runError || null,
          source: null,
          threadId: run.threadId,
          workflowRunId: null
        }));

  return rows.sort((left, right) => String(right.startedAt || '').localeCompare(String(left.startedAt || '')));
};

export default buildAutomationRunRows;
